module.exports = __webpack_public_path__ + "static/media/c7f2f197-1be0-4191-90fb-0e8ecd90ecc4.c42fdf4e.JPG";